module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_",
    attrs: {
      "id": "id_Hlk161510719"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('img', {
    staticClass: "calibre1",
    attrs: {
      "alt": "Image",
      "src": "images/image.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("Born in Melbourne, Victoria, Portia Stanton-Noble currently lives in the Gilbert Valley, South Australia in her private hotel with her son. When she was eight years old, she had already made up her mind that she was going to be a writer.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("This novel is the fourth and final instalment of the series, following "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("The Big Dead Dry")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Pretty Dead Ordinary and Drop Dead Like Flies.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_vm._v("Since completing the murder mysteries and romantic intrigues surrounding her characters in the fictional township of Brumby Flat, she has been busy researching material for her next books.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c112f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0